import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

import { Column } from '@prisjakt/ui/list/variants';

const GUTTER = layout.measurements.spacing100;

export const SearchResults = styled(Column)`
  padding: 0 ${GUTTER};
  margin-bottom: ${GUTTER};
  margin-top: ${GUTTER};
`;

export const Section = styled.div``;

export const ModuleWrapper = styled.div`
  padding: 0 ${GUTTER};
`;

export const FilterWrapper = styled.div`
  ${media.mediumDown`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: ${layout.measurements.spacing050};
    margin-bottom: ${layout.measurements.spacing050};
  `}
`;
